import { buildProps } from '@ll-plus/utils'
import type { ExtractPropTypes } from 'vue'
import type Textarea from './textarea.vue'

export const textareaProps = buildProps({
  useResize: {
    type: Boolean,
    default: false,
  },
  // 是否只读
  readonly: {
    type: Boolean,
    default: false,
  },
  // 最大长度
  maxlength: {
    type: Number,
  },
  isGray: {
    type: Boolean,
    default: false,
  },
} as const)

export type TextareaProps = ExtractPropTypes<typeof textareaProps>
export type TextareaInstance = InstanceType<typeof Textarea>
